<template>
<div id="container" class="active spiele_memory schwer">
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <div class="fullscreen_background z1 active">
        <img src="/static/assets/spiele_memory/Hintergrund_2860.png" />
    </div>
  <div class="z2 active text" ><img src="/static/assets/spiele_memory/spiele_memory_text_schwer.png"></div>
  <div class="z50 active textplaybutton pointer" @click="starttextplay"><img src="/static/assets/alle/Play_Button.png"/></div>
    <div class="cards_auswahl active z3">
      <div class="z3 active karte_top restart" id="memory_schwer_restart"><img src="/static/assets/spiele_memory/spiele_memory_Karte_gross_level_02.jpg"></div>
      <router-link tag="div" to="/spielememory" class="z3 active karte_bottom_01"><img src="/static/assets/spiele_memory/spiele_memory_leicht.png"></router-link>
      <router-link tag="div" to="/spielememory_mittel" class="z3 active karte_bottom_02"><img src="/static/assets/spiele_memory/spiele_memory_mittel.png"></router-link>
      <router-link tag="div" to="/spielememory_schwer" class="z3 active karte_bottom_03"><img src="/static/assets/spiele_memory/spiele_memory_schwer.png"></router-link>
    </div>
    <section class="score-panel z10">
      <ul class="stars">
        <li><i class="fa fa-star"></i></li>
        <li><i class="fa fa-star"></i></li>
        <li><i class="fa fa-star"></i></li>
      </ul>
      <span class="moves"></span>
        <div class="timer"></div>
        <div class="restart" onclick=startGame()>
        <i class="fa fa-repeat"></i>
      </div>
    </section>
    <div class="cards_memory active z4">
    <ul class="deck cm_schwer" id="card-deck-schwer">
        <li class="card card-schwer" type="L02">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_01.png">
        </li>
        <li class="card card-schwer" type="L03">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_02.png">
        </li>
        <li class="card card-schwer" type="L04" >
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_03.png">
        </li>
        <li class="card card-schwer" type="L05">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_04.png">
        </li>
        <li class="card card-schwer" type="L06">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_05.png">
        </li>
        <li class="card card-schwer" type="L07">
           <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_06.png">
        </li>
        <li class="card card-schwer" type="L08">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_07.png">
        </li>
        <li class="card card-schwer" type="L09">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_08.png">
        </li>
        <li class="card card-schwer" type="L10">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_09.png">
        </li>
        <li class="card card-schwer" type="L02">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_01.png">
        </li>
        <li class="card card-schwer" type="L03">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_02.png">
        </li>
        <li class="card card-schwer" type="L04" >
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_03.png">
        </li>
        <li class="card card-schwer" type="L05">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_04.png">
        </li>
        <li class="card card-schwer" type="L06">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_05.png">
        </li>
        <li class="card card-schwer" type="L07">
           <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_06.png">
        </li>
        <li class="card card-schwer" type="L08">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_07.png">
        </li>
        <li class="card card-schwer" type="L09">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_08.png">
        </li>
        <li class="card card-schwer" type="L10">
            <img src="/static/assets/spiele_memory/spiele_memory_sticker_schwer_09.png">
        </li>
      </ul>
    </div>
    <div class="gewonnen active z50" id="popup3">
            <div class="gewonnen_oben_konfetti active"><img src="/static/assets/spiele_memory/Konfetti.png"></div>
            <div class="gewonnen_oben active"><img src="/static/assets/spiele_memory/Luftschlangen.png"></div>
            <div class="gewonnen_unten active"><img src="/static/assets/spiele_memory/Hugidubies.png"></div>
          </div>
</div>
</template>

<script>
/* eslint no-unused-vars:0 */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Spielememory_schwer',
  data () {
    return {
      who: 'Spielememory_schwer'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright
 },
  methods:{
    starttextplay () {
      console.log('starttextplay')
        try {
            window.currentAudioX.pause()
            window.currentAudioX.currentTime = 0
            window.currentAudioX = null
        } catch (e) {
            console.log('pause geht nicht')
        }
        window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Am_schwersten_9Paare.mp3')
        var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
        window.currentAudioX.muted = muted
        window.currentAudioX.play()
    }
  },
   mounted () {
    this.$ga.page(this.$router)
    /* eslint-disable */
    $(function(){
            // cards array holds all cards
            let card = document.getElementsByClassName("card-schwer");
            let cards = Object.values(card);
            console.log(cards);

            // deck of all cards in game
            const deck = document.getElementById("card-deck-schwer");

            // declaring move variable
            let moves = 0;
            let counter = document.querySelector(".schwer .moves");

            // declare variables for star icons
            const stars = document.querySelectorAll(".schwer .fa-star");

            // declaring variable of matchedCards
            let matchedCard = document.getElementsByClassName("match");

             // stars list
             let starsList = document.querySelectorAll(".schwer .stars li");

             // close icon in modal
             let closeicon = document.querySelector(".schwer .close");

             // declare modal
             let modal = document.getElementById("popup3")

             // array for opened cards
            var openedCards = [];

            // @description shuffles cards
            // @param {array}
            // @returns shuffledarray
            function shuffle(array) {
                var currentIndex = array.length, temporaryValue, randomIndex;

                while (currentIndex !== 0) {
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;
                    temporaryValue = array[currentIndex];
                    array[currentIndex] = array[randomIndex];
                    array[randomIndex] = temporaryValue;
                }

                return array;
            };


            // @description function to start a new play
            function startGame(){
            if (typeof window.memo1 === 'undefined') {
               window.memo1 = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Spiele_noch_einmal_long.mp3')
            }
            if (typeof window.memo2 === 'undefined') {
               window.memo2 = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Karte1.mp3')
            }
            if (typeof window.memo3 === 'undefined') {
               window.memo3 = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Karte2Match.mp3')
            }
            if (typeof window.memo4 === 'undefined') {
            //   window.memo4 = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Karte2noMatch.mp3')
            }
            if (typeof window.memo5 === 'undefined') {
               window.memo5 = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Memo_Siegerjubel.mp3')
            }
            window.memo1.play()
                // shuffle deck
                cards = shuffle(cards);
                // remove all exisiting classes from each card
                for (var i = 0; i < cards.length; i++){
                    deck.innerHTML = "";
                    [].forEach.call(cards, function(item) {
                        deck.appendChild(item);
                    });
                    cards[i].classList.remove("show", "open", "match", "disabled");
                }
                // reset moves
                moves = 0;
                counter.innerHTML = moves;
                // reset rating
                for (var i= 0; i < stars.length; i++){
                    stars[i].style.color = "#FFD700";
                    stars[i].style.visibility = "visible";
                }
                //reset timer
                var second = 0;
                var minute = 0;
                var hour = 0;
                var timer = document.querySelector(".schwer .timer");
                timer.innerHTML = "0 mins 0 secs";
                clearInterval(interval);
            }


            // @description toggles open and show class to display cards
            var displayCard = function (){
                this.classList.toggle("open");
                this.classList.toggle("show");
                this.classList.toggle("disabled");
                window.memo2.play()
            };


            // @description add opened cards to OpenedCards list and check if cards are match or not
            function cardOpen() {
                openedCards.push(this);
                var len = openedCards.length;
                if(len === 2){
                    moveCounter();
                    // console.log('opencards 0', openedCards[0].type, 'opencards 1', openedCards[1].type)
                    var c1 = openedCards[0].getAttribute('type')
                    var c2 = openedCards[1].getAttribute('type')
                    // console.log('c1:', c1, 'c2: ', c2)
                    if(c1 === c2){
                       matched();
                        window.memo3.play()
                    } else {
                        unmatched();
                        // window.memo4.play()
                    }
                }
            };


            // @description when cards match
            function matched(){
                openedCards[0].classList.add("match", "disabled");
                openedCards[1].classList.add("match", "disabled");
                openedCards[0].classList.remove("show", "open", "no-event");
                openedCards[1].classList.remove("show", "open", "no-event");
                openedCards = [];
            }


            // description when cards don't match
            function unmatched(){
                openedCards[0].classList.add("unmatched");
                openedCards[1].classList.add("unmatched");
                disable();
                setTimeout(function(){
                    openedCards[0].classList.remove("show", "open", "no-event","unmatched");
                    openedCards[1].classList.remove("show", "open", "no-event","unmatched");
                    enable();
                    openedCards = [];
                },1100);
            }


            // @description disable cards temporarily
            function disable(){
                Array.prototype.filter.call(cards, function(card){
                    card.classList.add('disabled');
                });
            }


            // @description enable cards and disable matched cards
            function enable(){
                Array.prototype.filter.call(cards, function(card){
                    card.classList.remove('disabled');
                    for(var i = 0; i < matchedCard.length; i++){
                        matchedCard[i].classList.add("disabled");
                    }
                });
            }


            // @description count player's moves
            function moveCounter(){
                moves++;
                counter.innerHTML = moves;
                //start timer on first click
                if(moves == 1){
                    second = 0;
                    minute = 0;
                    hour = 0;
                    startTimer();
                }
                // setting rates based on moves
                if (moves > 8 && moves < 12){
                    for( i= 0; i < 3; i++){
                        if(i > 1){
                            stars[i].style.visibility = "collapse";
                        }
                    }
                }
                else if (moves > 13){
                    for( i= 0; i < 3; i++){
                        if(i > 0){
                            stars[i].style.visibility = "collapse";
                        }
                    }
                }
            }


            // @description game timer
            var second = 0, minute = 0, hour = 0;
            var timer = document.querySelector(".timer");
            var interval;
            function startTimer(){
                interval = setInterval(function(){
                    timer.innerHTML = minute+"mins "+second+"secs";
                    second++;
                    if(second == 60){
                        minute++;
                        second=0;
                    }
                    if(minute == 60){
                        hour++;
                        minute = 0;
                    }
                },1000);
            }


            // @description congratulations when all cards match, show modal and moves, time and rating
        function congratulations(){
            if (matchedCard.length == 18){
                clearInterval(interval);
                // finalTime = timer.innerHTML;
                window.memo5.muted = window.muted
                window.memo5.play()
                // show congratulations modal
                modal.classList.add("show");

                // declare star rating variable
                // var starRating = document.querySelector(".leicht .stars").innerHTML;

                //showing move, rating, time on modal
                // document.getElementById("finalMove").innerHTML = moves;
                // document.getElementById("starRating").innerHTML = starRating;
                // document.getElementById("totalTime").innerHTML = finalTime;

                //closeicon on modal
                closeModal();
            };
        }


            // @description close icon on modal
            function closeModal(){
                modal.addEventListener("click", function(e){
                    modal.classList.remove("show");
                    startGame();
                });
            }


            // @desciption for user to play Again
            function playAgain(){
                modal.classList.remove("show");
                startGame();
            }


            // loop to add event listeners to each card
            for (var i = 0; i < cards.length; i++){
                card = cards[i];
                card.addEventListener("click", displayCard);
                card.addEventListener("click", cardOpen);
                card.addEventListener("click",congratulations);
            };

            startGame();
            $('#memory_schwer_restart').on('click', function () {
              startGame()
            })
        }); // namespace geklammert
        var self = this
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
        } catch (e) {
            console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
        } catch (e) {
            console.log('pause geht nicht')
        }
      }
      var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
      window.currentAudioX = new Audio ('/static/assets/sounds/03a_Memo-Seite/Sprache/Hugidubies_Am_schwersten_9Paare.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
    }, 1000);
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



<style scoped>body {margin:0; padding:0;}
.fullscreen_background.z1.active {
    transform: perspective(400px);
    -webkit-transform: translateZ(-1000px);
    z-index: -99999;
}
/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

html {
        box-sizing: border-box;
}

*,
*::before,
*::after {
        box-sizing: inherit;
}

html,
body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
}

body {
        background: #ffffff;
        font-family: 'Permanent Marker', cursive;
        font-size: 16px;
}

.container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
}

h1 {
        font-family: 'Gloria Hallelujah', cursive;
}


/*
 * Styles for the deck of cards
 */
li.card {
    margin-bottom: 4% !important;
}

.deck {
        /* width: 85%; */
        background: none;
        padding: 1rem;
        border-radius: 4px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
        margin: 0 0 3em;
}

.deck .card {
        height: 258px;
        width: 195px;
        margin: 0.2rem 0.2rem;
        background: #141214;
        background-image: url(/static/assets/spiele_memory/spiele_memory_sticker_leicht_00.png);
        font-size: 0;
        color: #ffffff;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 5px 2px 20px 0 rgba(46, 61, 73, 0.5);
}
.deck .card img {opacity:0; transition: all 0.5s linear; border-radius: 5px;}
.deck .card.open {
        transform: rotateY(0);
        background: #FFFFFF;
        cursor: default;
        animation-name: flipInY;
        -webkit-backface-visibility: visible !important;
        backface-visibility: visible !important;
        animation-duration: .75s;
}
.deck .card.open img {opacity:1; border-radius: 5px;}
.deck .card.show {
        font-size: 33px;
}

.deck .card.match {
        cursor: default;
        background: none;
        font-size: 33px;
        animation-name: rubberBand;
        -webkit-backface-visibility: visible !important;
        backface-visibility: visible !important;
        animation-duration: .75s;
}
.deck .card.match img {opacity:1; border-radius: 5px;}
.deck .card.unmatched {
        animation-name: pulse;
        -webkit-backface-visibility: visible !important;
        backface-visibility: visible !important;
        animation-duration: .75s;
        background: #e2043b;
}

.deck .card.disabled {
        pointer-events: none;
        opacity: 1;
}


/*
 * Styles for the Score Panel
 */


.score-panel {
        text-align: left;
        margin-bottom: 10px;
}

.score-panel .stars {
        margin: 0;
        padding: 0;
        display: inline-block;
        margin: 0 5px 0 0;
}

.score-panel .stars li {
        list-style: none;
        display: inline-block;
}

.score-panel .restart {
        float: right;
        cursor: pointer;
}

.fa-star {
        color: #FFD700;
}

.timer {
        display: inline-block;
        margin: 0 1rem;
}


/*
 * Styles for congratulations modal
 */


.overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.7);
        transition: opacity 500ms;
        visibility: hidden;
        opacity: 0;
}

.overlay:target {
        visibility: visible;
        opacity: 1;
}

.popup {
        margin: 70px auto;
        padding: 20px;
        background: #ffffff;
        border-radius: 5px;
        width: 85%;
        position: relative;
        transition: all 5s ease-in-out;
        font-family: 'Gloria Hallelujah', cursive;
}

.popup h2 {
        margin-top: 0;
        color: #333;
        font-family: Tahoma, Arial, sans-serif;
}

.popup .close {
        position: absolute;
        top: 20px;
        right: 30px;
        transition: all 200ms;
        font-size: 30px;
        font-weight: bold;
        text-decoration: none;
        color: #333;
}

.popup .close:hover {
        color: #E5F720;
}

.popup .content-1,
.content-2 {
        max-height: 30%;
        overflow: auto;
        text-align: center;
}

.show {
        visibility: visible !important;
        opacity: 100 !important;
}

#starRating li {
        display: inline-block;
}

#play-again {
        background-color: #141214;
        padding: 0.7rem 1rem;
        font-size: 1.1rem;
        display: block;
        margin: 0 auto;
        width: 50%;
        font-family: 'Gloria Hallelujah', cursive;
        color: #ffffff;
        border-radius: 5px;
}

/* animations */
@keyframes flipInY {
        from {
                transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
                animation-timing-function: ease-in;
                opacity: 0;
        }

        40% {
                transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
                animation-timing-function: ease-in;
        }

        60% {
                transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
                opacity: 1;
        }

        80% {
                transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
        }

        to {
                transform: perspective(400px);
        }
}

@keyframes rubberBand {
        from {
                transform: scale3d(1, 1, 1);
        }

        30% {
                transform: scale3d(1.25, 0.75, 1);
        }

        40% {
                transform: scale3d(0.75, 1.25, 1);
        }

        50% {
                transform: scale3d(1.15, 0.85, 1);
        }

        65% {
                transform: scale3d(.95, 1.05, 1);
        }

        75% {
                transform: scale3d(1.05, .95, 1);
        }

        to {
                transform: scale3d(1, 1, 1);
        }
}

@keyframes pulse {
        from {
                transform: scale3d(1, 1, 1);
        }

        50% {
                transform: scale3d(1.2, 1.2, 1.2);
        }

        to {
                transform: scale3d(1, 1, 1);
        }
}

/****** Media queries
***************************/

@media (max-width: 320px) {
        .deck {
                width: 85%;
        }

/*      .deck .card {
                height: 4.7rem;
                width: 4.7rem;
        } */
}

/* For Tablets and larger screens
****************/

@media (min-width: 768px) {
/*              .container {
                font-size: 22px;
        }

        .deck {
                width: 660px;
                height: 680px;
        }

.deck .card {
                height: 125px;
                width: 125px;
        } */

        .popup {
                width: 60%;
        }
}
/* memory app ende*/


/* SPIELE */
.spiele_start .memo_01 {
    bottom: 14.5%;
    left: 21%;
}
.spiele_start .memo_02 {
    bottom: 30%;
    left: 17%;
}
.spiele_start .malen_01 {
    bottom: 14.5%;
    right: 22.5%;
}
.spiele_start .malen_02 {
    bottom: 30%;
    left: 57%;
}

.spiele_start #menulayer {
    top: 3.5%;
    right: 22%;
}
.spiele_start .logoshine{top:0%; left:15%;}
.spiele_start .logo{top: 3%; left: 14%;}
.spiele_start div {
    position: absolute;
    width: 286px;
                }
.spiele_start div{display:none;}
.spiele_start .active{display:block !important;}
.spiele_start #spiele_start{position: absolute; width: 1920px; height: 1080px;}

/* SPIELE ausmalen*/
.spiele_ausmalen .malen_slider {
    height: 100%;
    width: 100%;
}
.spiele_ausmalen .pfeil_links {
    left: 35%;
    bottom: 41%;
}
.spiele_ausmalen .pfeil_rechts {
    right: 8%;
    bottom: 41%;
}
.spiele_ausmalen .figur {
    left: 39.5%;
    bottom: 4%;
}
.spiele_ausmalen .text {
    bottom: 41%;
    left: 14%;
}
.spiele_ausmalen .download {
    bottom: 19%;
    left: 19%;
}
.spiele_ausmalen .front {
    bottom: -4px;
    right: 28%;
}
.spiele_ausmalen div {
    position: absolute;
    width: 286px;
                }
.spiele_ausmalen div{display:none;}
.spiele_ausmalen .active{display:block !important;}
.spiele_ausmalen #spiele_ausmalen{position: absolute; width: 1920px; height: 1080px;}

/* SPIELE memory*/
.spiele_memory .malen_slider {
    height: 100%;
    width: 100%;
}
.spiele_memory .cards_auswahl {
    height: 100%;
    width: 100%;
}

.cards_auswahl img {
    box-shadow: 4px 4px 10px rgba(0,0,0,0.5);
}
.karte_top {
    bottom: 260px;
    left: 14%;
}
.karte_bottom_01 {
    left: 14%;
    bottom: 14%;
}
.karte_bottom_02 {
    left: 19.5%;
    bottom: 14%;
}
.karte_bottom_03 {
    left: 25.8%;
    bottom: 14%;
}

.cards_memory {
    width: 50%;
    height: 30%;
}
.cards_memory {
    width: 50%;
    height: 70%;
    bottom: 0;
    right: 14.5%;
    border: 0px solid;
}
.spiele_memory .karte {
    float: left;
    position: relative;
    margin-right: 4%;
    margin-bottom: 3%;
}
.spiele_memory .karte img {
    box-shadow: 4px 4px 10px rgba(0,0,0,0.5);
}
.spiele_memory .text {
    bottom: 75.5%;
    right: 14%;
}
.spiele_memory .download {
    bottom: 19%;
    left: 19%;
}
.spiele_memory .front {
    bottom: -4px;
    right: 28%;
}

.spiele_memory #menulayer {
    top: 3.5%;
    right: 22%;
}

.spiele_memory div {
    position: absolute;
}

.spiele_memory div{display:none;}
.spiele_memory .active{display:block !important;}
.spiele_memory #spiele_memory{position: absolute; width: 1920px; height: 1080px;}

.cards_memory .cm_mittel {
    height: 30%;
    width: 45%;
    height: 70%;
    bottom: 0;
    right: 20.5%;
    border: 0 solid;
}

.deck .card-mittel {
    height: 180px;
    width: 135px;
    margin: .2rem;
    background: #141214;
    background-image: url(/static/assets/spiele_memory/spiele_memory_sticker_mittel_00.jpg);
    font-size: 0;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    -ms-flex-pack: center;
    justify-content: center;
    box-shadow: 5px 2px 20px 0 rgba(46,61,73,.5);
}

#card-deck-mittel li.card{
    margin-bottom: 2%!important;
}

.cards_memory .cm_schwer {
    height: 30%;
    width: 53%;
    height: 70%;
    bottom: 0;
    right: 14.5%;
    border: 0 solid;
}
.deck .card-schwer {
    height: 163px;
    width: 122px;
    margin: .2rem;
    background: #141214;
    background-image: url(/static/assets/spiele_memory/spiele_memory_sticker_schwer_00.png);
    font-size: 0;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    -ms-flex-pack: center;
    justify-content: center;
    box-shadow: 5px 2px 20px 0 rgba(46,61,73,.5);
}

#card-deck-schwer li.card{
    margin-bottom: 2%!important;
}
.cards_memory{
    width: 46%;
    height: 66%;
    bottom: 0;
    right: 20.5%;
    border: 0 solid;
}
.cards_memory .cm_schwer {
    height: 30%;
    width: 100%;
    height: 70%;
    bottom: 50px;
    right: 14.5%;
    border: 0 solid;
}
.logo, .menu{display:inherit !important;}
area, .lautsprecher, .restart, .karte_bottom_01, .karte_bottom_02, .karte_bottom_03, .minuten_01, .minuten_02, .memo_01, .memo_02, .malen_01, .malen_02 {
    cursor: pointer;
}
.gewonnen {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: -25%;
    z-index: -100 !important;
    opacity:0;
}
.gewonnen.show {
    z-index: 100 !important;
  cursor: pointer;
  opacity:1;
}
.gewonnen_oben {
    position: absolute;
    top: -1000px;
    transition: all 0.5s ease-out;
}
.show .gewonnen_oben {
    position: absolute;
    top: 0px;
}
.gewonnen_oben_konfetti {
    position: absolute;
    top: -1100px;
    transition: all 10s ease-out;
}
.show .gewonnen_oben_konfetti {
    position: absolute;
    top: 0px;
}
.gewonnen_unten.active {
    position: absolute;
    bottom: -1000px;
    transition: all 0.5s ease-out
}
.show .gewonnen_unten.active {
    position: absolute;
    bottom: -275px;
}
.moves{display:none !important; text-indent:-99999999999px; position: absolute; left:-10000px;}
.z50.active.textplaybutton.pointer {
    top: 178px;
    left: 1630px;
}
.z50.active.textplaybutton.pointer img {
    width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Spielememory_schwer.vue